// @flow

export default (href: string): string => {
    return href;
};
